import { ResearchNotifications } from 'notifications-from-civil-status/view-models/notifications-list';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';

export const transformNotificationsDataset = (
  values: ResearchNotifications,
  page?: number,
  rowsPerPage?: number
): string => {
  const transformedFilters: OperationObject = {
    idEvento: {
      value: values.idEvent || '',
      operation: Operation.EQUALS,
    },
    cdComunicazione: {
      value: values.code || '',
      operation: Operation.EQUALS,
    },
    cdStatoAggiornamento: {
      value: values.state || '',
      operation: Operation.EQUALS,
    },
    cdAmbito: {
      value: values.scope || '',
      operation: Operation.EQUALS,
    },
    cdMittente: {
      value: values.municipalityFormation || '',
      operation: Operation.EQUALS,
    },
    tipoEvento: {
      value: values.typeEvent || '',
      operation: Operation.EQUALS,
    },
    descIntestatario: {
      value: values.owners || '',
      operation: Operation.LIKE,
    },
    dataDa: {
      value: values.dateStart ? values.dateStart.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    dataA: {
      value: values.dateEnd ? values.dateEnd.toFormat('yyyy-MM-dd') : '',
      operation: Operation.EQUALS,
    },
    codiceOperatore: {
      value: values?.codOperator || '',
      operation: Operation.EQUALS,
    },
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: {},
    page: page || 0,
    rowsPerPage: rowsPerPage || 10,
  })}`;
};
